import { render, staticRenderFns } from "./modalEditServiceTicket.vue?vue&type=template&id=2de32b90&"
import script from "./modalEditServiceTicket.vue?vue&type=script&lang=js&"
export * from "./modalEditServiceTicket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports